const ns = {}

ns.keys = {
  accessToken: 'accessToken',
  loginRedirectUrl: 'loginRedirectUrl',
  inviteGroupId: 'inviteGroupId',
  inviteCode: 'inviteCode'
}

ns.getAccessToken = function () {
  return localStorage.getItem(ns.keys.accessToken)
}

export default ns
